<h3 mat-dialog-title>{{data.dialogTitle}}</h3>
<img (click)="closeDialog(false)" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<!-- yes, 2 mat dialog contents... an easy way to match the design in this case -->
<form [formGroup]="form">
    <mat-dialog-content>
        <div class="form-group">
            <label>Bank Account Name:</label>
            <input class="form-control  form-control-sm" formControlName="accountName">
        </div>

        <ng-container *ngIf="data.promptAccountNumbers">

            <div class="form-group">
                <label>Bank Routing Number:</label>
                <input class="form-control  form-control-sm" formControlName="routingNumber" maxlength="9">
            </div>

            <div class="form-group">
                <label>Bank Account Number:</label>
                <input class="form-control  form-control-sm" formControlName="accountNumber" minlength="6">
            </div>

            <p>
                Please confirm your account and routing numbers to finish setting up this account.
            </p>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-content>
        <div *ngIf="data.context === 'organization'" class="form-group">
            <mat-slide-toggle
                [disabled]="disableDeposits"
                formControlName="useForDeposits">
                <label>Save as a deposit account for online payments from homeowners.</label>
            </mat-slide-toggle>
        </div>

        <div *ngIf="data.context === 'organization'" class="form-group">
            <mat-slide-toggle
                [disabled]="disablePayments"
                formControlName="useForPayments">
                <label>Save as a payment method for PayHOA subscription
                    fees.</label>
            </mat-slide-toggle>
        </div>

        <div *ngIf="data.promptUseForTransactions && data.context === 'organization'"
             [matTooltipDisabled]="data.supportsTransactions"
             class="form-group" matTooltip="This banking institution does not support importing your transaction history.">
            <mat-slide-toggle
                [disabled]="!data.supportsTransactions"
                formControlName="useForTransactions">
                <label>Sync bank transactions to PayHOA accounting
                    system.</label>
            </mat-slide-toggle>
        </div>

        <re-captcha
            (resolved)="form.get('captchaToken').setValue($event)"
            siteKey="{{siteKey}}"
        ></re-captcha>
    </mat-dialog-content>
</form>

<mat-dialog-actions>
    <button (click)="closeDialog(false)" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="closeDialog(true)"
            [disabled]="!form.valid"
            class="btn btn-primary"
            type="button">{{this.data.confirmButtonText}}
    </button>
</mat-dialog-actions>
